<script>
    import {modelToolHelpers} from '../../../vendor/rmts/scoop-os/resources/js/mixins/model-tool-helpers'

    export default {
        mixins: [
            modelToolHelpers('ThomassaboModelSelectorToolsEcomMediaFlagWarning')
        ],
        computed: {
            ecomCount() {
                return this.countApplicableModels();
            }
        }
    }
</script>
<template>
    <div class="col-xs-12" v-if="ecomCount > 0">
        <div class="alert alert-warning" role="alert">
            <strong>Please be careful!</strong>
            <span>{{ ecomCount }} selected media are for digital use only. Use in other areas of application, such as print production, is not permitted.</span>
        </div>
    </div>
</template>
